<script setup>
import {useFlowStore} from "../../Registration/stores/flowStore";
import {computed} from "vue";
import {useBookingStore} from "../../Registration/stores/bookingStore";
import EditRegistrationButton from "../../Registration/components/EditRegistrationButton.vue";
import {useSettingsManager} from "../../Registration/stores/settingsManagerStore";

const flow = useFlowStore();
const booking = useBookingStore();
const {settings} = useSettingsManager();
const shouldDisplayEndMessage = computed(() => {
    if(flow.formSubmission === 'success'){
        return true;
    }
    const guestStatus = booking.status;
    const guestAuthenticated = guestStatus !== null;
    if(!guestAuthenticated){
        return flow.formSubmission === 'success';
    }
    const guestStatusDefault = ['invited','listed'].includes(guestStatus)

    return !guestStatusDefault && !flow.isFormEditionActive;
});
const resolveTextToDisplay = computed(() => {
    switch (booking.data.status) {
        case "confirmed":
            return settings?.messages.confirmation;
        case "requested":
            return settings?.messages['request-confirmation'];
        case "waitlisted":
            return settings?.messages['waitlist-confirmation']
        case "cancelled":
            return settings?.messages['declination']
        default:
            return "";
    }
});
</script>

<template>
    <div v-show="shouldDisplayEndMessage">
        <div class="registration-confirmation-message text-center flex flex-col items-center justify-center border border-[#E6E7EB] py-6">
            <div v-html="resolveTextToDisplay"></div>
            <EditRegistrationButton />
        </div>
    </div>
</template>

<style scoped>

</style>
